export default "__VITE_ASSET__BjA5jcF$__"